import axios from "axios";

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL;

/**
 * Get Fasten configuration (public ID for Stitch.js widget)
 */
export const getFastenConfig = async (token) => {
  let error;
  let data;

  try {
    const response = await axios.get(`${apiServerUrl}/api/fasten/config/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    data = response.data;
  } catch (err) {
    error = err.response?.data?.error || err.message;
  }

  return {
    data,
    error,
  };
};

// Alias for consistency
export const getFastenConnectConfig = getFastenConfig;

/**
 * Send connection callback data from Stitch.js widget
 */
export const sendConnectionCallback = async (token, connectionData) => {
  let error;
  let data;

  try {
    const response = await axios.post(
      `${apiServerUrl}/api/fasten/connection/callback/`,
      connectionData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    data = response.data;
  } catch (err) {
    error = err.response?.data?.error || err.message;
  }

  return {
    data,
    error,
  };
};

// Alias for consistency
export const postFastenConnectionCallback = sendConnectionCallback;

/**
 * Get Fasten patient status for current user
 */
export const getFastenStatus = async (token) => {
  let error;
  let data;

  try {
    const response = await axios.get(`${apiServerUrl}/api/fasten/status/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    data = response.data;
  } catch (err) {
    error = err.response?.data?.error || err.message;
  }

  return {
    data,
    error,
  };
};

